// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__3wSQz","icon":"Card_icon__2CHl-","msg":"Card_msg__L2of0"};